import React, { Component } from 'react';
import { Link } from 'react-router'
import { Navbar, Image } from 'react-bootstrap';

class NavSignedIn extends Component {

  render() {
    return (
      <Navbar.Text>
        <Image src={this.props.photoURL} style={{height:30, width:30}} alt="Profile Pic" circle /> &nbsp; {this.props.name}&nbsp;&nbsp;-&nbsp;&nbsp;<Link to="/logout">Sign out</Link>
      </Navbar.Text>
    );
  }

}

export default NavSignedIn;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavSignedIn.js